<template>
  <div v-show="property">
    <div
      class="items-center hidden p-2 border border-gray-200 md:flex md:justify-between rounded-b-xl bg-gray-50"
    >
      <div>
        <AgentAndDateListed :property="property" />
      </div>
      <div class="flex items-end justify-end">
        <ActionButtons :property="property" />
      </div>
    </div>
    <div
      class="flex justify-between w-full p-1 space-x-2 border-t md:hidden md:space-x-5"
      v-if="property.agent"
    >
      <a
        :href="
          'mailto:' +
          property.agent.email +
          '?subject=New property&body=I want to find out more about this property.'
        "
        class="text-primary px-2 py-2 md:px-3 rounded-lg hover:transition duration-200 ease-in-out w-full bg-[#f7f6fb] hover:bg-[#E3E1F2] flex items-center font-medium text-sm justify-center"
      >
        <EmailSvg color="primary" height="4" width="4" />
        <span class="ml-1 text-sm">Email</span>
      </a>
      <a
        target="__blank"
        :href="`https://wa.me/ + ${property.agent.phone} + ?text=I want to find out more about this property`"
        class="text-primary py-2 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out w-full bg-[#f7f6fb] hover:bg-[#E3E1F2] flex items-center font-medium text-sm justify-center"
      >
        <WhatsAppSvg color="primary" height="4" width="4" />
        <span class="ml-1 text-sm">WhatsApp</span>
      </a>
    </div>
  </div>
</template>
<script>
import AgentAndDateListed from "@/features/properties/components/AgentAndDateListed.vue";
import ActionButtons from "@/features/properties/components/ActionButtons.vue";
import EmailSvg from "@/components/svg/EmailSvg.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
export default {
  name: "PropertyCardFooter",
  components: {
    AgentAndDateListed,
    ActionButtons,
    EmailSvg,
    WhatsAppSvg,
  },
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  setup() {},
};
</script>
